import { Box} from "@chakra-ui/react";
import ClientContainer from "views/Customers/CustomerList/ClientContainer";
import CustomerList from "views/Customers/CustomerList/customerList";

const Client = ({}) => {
  return (
    <>
   <ClientContainer/>
    </>
  );
};

export default Client;
